import * as React from "react";
export var DefaultIndexInfo = function DefaultIndexInfo(props) {
  return React.createElement("div", null, "Kies het magazine dat je wil bekijken");
};